import StepCard from './StepCard';
import type { HowItWorksProps } from './useHowItWorks';

const HowItWorksMobile = ({ data }: HowItWorksProps) => {
  return (
    <section
      id="how-it-works"
      className="flex flex-col items-center gap-10 bg-surface-card px-6 py-16"
    >
      <div className="flex flex-col items-center gap-4 text-center">
        <span className="font-body text-xs font-semibold tracking-widest text-accent-text">
          {data.label}
        </span>
        <h2 className="font-heading text-3xl font-medium text-foreground-primary">
          {data.title}
        </h2>
      </div>

      <div className="flex w-full flex-col gap-12">
        {data.steps.map((step) => (
          <StepCard key={step.id} step={step} />
        ))}
      </div>
    </section>
  );
};

export default HowItWorksMobile;
